import { gql } from '@apollo/client';
import {
  getContextQueryVariables,
  getContextFilterClientExports,
  getContextFiltersQueryArguments,
} from '../../../helpers/contextFilters';

// gameIds excluded: video modal is already scoped to a single game via gameId
// qbPassLocation excluded: backend crashes on null when filter is disabled
const contextFilterOverrides = { gameIds: false, qbPassLocation: false };

export const GET_STATS_VIDEO = gql`
  query GetStatsVideo(
    $competitionId: Int!
    $seasonId: Int!
    $playerId: Int!
    $teamId: Int!
    $position: GeneralPosition!
    $statName: String!
    $gameId: Int
    ${getContextQueryVariables(contextFilterOverrides)}
  ) {
    selectedCompetitionId @client @export(as: "competitionId")
    selectedSeasonId @client @export(as: "seasonId")
    ${getContextFilterClientExports(contextFilterOverrides)}
    statsVideo(
      competitionId: $competitionId
      seasonId: $seasonId
      playerId: $playerId
      teamId: $teamId
      position: $position
      statName: $statName
      gameId: $gameId
      ${getContextFiltersQueryArguments(contextFilterOverrides)}
    ) {
      playId
    }
  }
`;
